var React = require('react');

class ThankYou extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="step-container step-zero">
        <h2>Welcome To Better Error Pages!</h2>
        <p className="works-header"><strong>Here's how this thing works:</strong></p>
        <ul className="styled">
          <li>We're going to ask you a few questions about your company.</li>
          <li>You're going to have the opportunity to customize what your error pages look like.</li>
          <li>When you're done, you'll be able to download the flat HTML files for your shiny new 404, 503 and Maintenance pages.</li>
        </ul>
        <p>Let's get started!</p>
      </div>
    )
  }

}

module.exports = ThankYou;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/walk_through/questions/welcome.jsx